import httpClient from "@/api/httpClient";

const API = 'https://api.joinroxie.com/api/v1'


export const getAllProducts = () => httpClient.get(`${API}/products`);

export const getAllCategories = () => httpClient.get(`${API}/categories`);
